import React from 'react';
import YouTube from 'react-youtube';

interface YouTubePlayerProps {
    videoId: string;
    onReady?: () => void;
}


const YouTubePlayer: React.FC<YouTubePlayerProps> = ({ videoId, onReady }) => {
    const handleReady = () => {
        if (onReady) onReady();
    };

    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            autoplay: 0,
        },
    };

    return (
        <div className="youtube-player-container">
            <YouTube
                videoId={videoId}
                opts={opts}
                onReady={handleReady}
            />
        </div>
    );
};

export default YouTubePlayer;
